import { turboproApi } from '@/api/turbopro';
import type { GravarCamposPayload } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function gravarCamposApi(payload: GravarCamposPayload): Promise<void> {
  const params = new URLSearchParams({
    relatorio_id: payload.relatorioId,
  });

  await turboproApi<null>(`Relatorios/GravarCampos?${params.toString()}`, {
    method: 'POST',
    body: payload.campos,
    headers: getRelatoriosHeaders(),
  });
}
